import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Eye, EyeOff } from "lucide-react";
import { loginUser } from "../api";
import { useNavigate } from "react-router-dom";
import Banner from "../components/Banner";

const Login = () => {
  const [formData, setFormData] = useState({
    username: "",
    contrasena: "",
    tipo_usuario: "Admin", // Default value
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Attempt to login the user
      const userData = await loginUser(formData);
      if (!userData || userData.error || !Array.isArray(userData) || !userData[0]) {
        setError(userData?.error || "Credenciales invalidas.");
        return;
      }

      login(userData);
      // Extract tipo_usuario from the user data
      const { tipo_usuario } = userData[0];

      // Redirect based on tipo_usuario
      if (tipo_usuario === "proveedor") {
        navigate("/proveedor", { state: { userData } });
      } else if (tipo_usuario === "cliente") {
        navigate("/cliente", { state: { userData } });
      } else if (tipo_usuario === "ingenieria") {
        navigate("/ingenieria", { state: { userData } });
      } else if (tipo_usuario === "finanzas") {
        navigate("/finanzas", { state: { userData } });
      } else if (tipo_usuario === "general_adser") {
        navigate("/general_adser", { state: { userData } });
      } else if (tipo_usuario === "general_sigma") {
        navigate("/general_sigma", { state: { userData } });
      } else if (tipo_usuario === "almacen") {
        navigate("/almacen", { state: { userData } });
      } else if (tipo_usuario === "lider") {
        navigate("/lider", { state: { userData } });
      } else if (tipo_usuario === "admin") {
        navigate("/admin", { state: { userData } });
      } else {
        // Log and throw error if tipo_usuario is invalid
        console.error("Invalid user type:", tipo_usuario);
        throw new Error("Invalid user type.");
      }
    } catch (err) {
      // Log the error if login or redirection fails
      console.error("Error during login:", err);
      setError("No fue posible iniciar sesion.");
    }
  };

  return (
    <div className="container-login">
      <Banner />
      <center><h1 className="title">Login</h1>
      <a href="/">home</a></center>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className="container2">
      <form onSubmit={handleSubmit} className="form">
        <div className="input-group">
          <label className="label">Usuario:</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            className="input-logon"
            required
            placeholder="nombre de usuario"
          />
        </div>
        <div className="input-group1">
          <label className="label">Contraseña:</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="contrasena"
              value={formData.contrasena}
              onChange={handleInputChange}
              className="input-logon"
              required
              placeholder="contraseña"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="password-toggle-btn"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div></div>
        <div>
          <label className="label">Tipo de Usuario:</label>
          <select
            name="tipo_usuario"
            value={formData.tipo_usuario}
            onChange={handleInputChange}
          >
            <option value="general_adser">Operadores Delta</option>
            <option value="general_sigma">Operadores Sigma</option>
            <option value="almacen">Almacen</option>
            <option value="lider">Lider</option>
            <option value="finanzas">Finanzas</option>
            <option value="ingenieria">Ingenieria</option>
            <option value="cliente">Cliente</option>
            <option value="proveedor">Proveedor</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <p></p>
        <button type="submit" className="button">Login</button>
      </form></div><br/><br/>
    </div>
  );
};

export default Login;
